<template>
  <div>
    <div v-if="searchedList.length === 0" class="no-content-message">
      There are currently no books to display.
    </div>
    <router-link :to="getBookLink(book)" v-for="(book, i) in searchedList" v-bind:key="i" class="book" v-bind:class="{'list-item': listView, 'list-view': listView, 'grid-view': !listView}">
      <div class="book-wrapper"  @click="needPurchase(book);">
        <img v-bind:class="{'book-cover': !book.requirePurchase, 'book-cover-needs-purchase' : book.requirePurchase}" :src="$config.get('ecApi') + 'web/books/' + book.id + '/cover?width=200'" alt="coverImage">        
        <div class="book-title" :title="book.title" v-bind:class="{'grid-view': !listView}">
          <span v-bind:class="{'book-title-text': !book.requirePurchase, 'book-title-text-needs-purchase' : book.requirePurchase}">{{book.title}}</span>
          <Popover placement="right" :width="470">
            <a class="more-info-button" @click.prevent=";"><span>more info</span><i class="fal fa-info-circle"></i></a>
            <div slot="content">
              <div v-if="book.metadata" class="more-info-content">
                <div class="details-wrapper">
                  <div class="tr">
                    <div class="info-title">Title:</div>
                    <div class="info-value">{{book.metadata.title}}</div>
                  </div>
                  <div class="tr">
                    <div class="info-title">Book ID:</div>
                    <div class="info-value">{{book.metadata.bookID}}</div>
                  </div>
                  <div class="tr">
                    <div class="info-title">ISBN:</div>
                    <div class="info-value">{{book.metadata.isbn}}</div>
                  </div>
                  <div class="tr">
                    <div class="info-title">Publisher:</div>
                    <div class="info-value">{{book.metadata.publisher}}</div>
                  </div>
                  <div class="tr">
                    <div class="info-title">Version:</div>
                    <div class="info-value">{{book.metadata.version}}</div>
                  </div>
                  <div v-if="book.licenceExpiryDateTime" class="tr">
                    <div class="info-title">Licence Expires on:</div>
                    <div class="info-value">{{moment.unix(book.licenceExpiryDateTime).format('DD MMM YYYY HH:mm')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </Popover>
        </div>
        <img class="book-type" :src="($config.get('basePathFiles') + 'static/img/' + (bookUtils.isPDF(book) ? 'icon_pdf_book.png' : 'icon_epub.png'))" />
        <span v-if="book.requirePurchase" class="needs-purchase">NEEDS PURCHASING</span>
        <span v-if="book.unreadResources > 0 && listView" @click.prevent="showUnreadResources(book)" class="unread" title="Resources not viewed yet">{{book.unreadResources}}</span>
        <span v-else-if="book.unreadResources > 0 && !listView" @click.prevent="showUnreadResources(book)" class="unread-grid-view" title="Resources not viewed yet"></span>
      </div>
    </router-link>

    <!-- Need Purchase Modal -->
    <div v-if="requirePurchase" class="modal no-select">
      <div class="modal-content">
        <h3 class="has-text-left">Needs purchasing</h3>
        <p class="has-text-left">This book has not been purchased. Please go to ITSI's online store and purchase the book in order to access it on miEbooks.</p>
        <div class="modal-buttons is-pulled-right">
          <button v-on:click.stop="requirePurchase = false" class="button">OK</button>
          <a :href="goToStore()" target="_blank" class="button is-primary">Go to Store</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import storeHelpers from '@/utils/storeHelpers.js';
import utils from '@/utils/utils.js';
import bookUtils from '@/utils/bookUtils.js';
import Popover from '@/components/widgets/popover';
import analytics from '@/utils/analytics.js'; 

const moment = require('moment');
require('moment-timezone');
moment.tz.setDefault('Africa/Johannesburg');

export default {
  name: 'books',
  components: {
    Popover
  },
  props: {
    bookList: {
      type: Array,
      required: true
    },
    listView: {
      type: Boolean,
      required: true
    },
    reverseSort: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      utils: utils,
      bookUtils: bookUtils,
      requirePurchase: false,
      moment: moment
    }
  },
  computed: {
    searchedList() {
      var t = this;
      var bookList = this.bookList.filter(book => {
        return book.title.toLowerCase().includes(this.search.toLowerCase()) && this.checkbookExpired(book)
      })
      return _.orderBy(bookList, [ function(book) { return book.title.trim().toLowerCase();} ], [t.reverseSort ? 'desc' : 'asc']);
    },
  },
  methods: {
    getBookLink: function (book) {
      var lastPageAccessed = storeHelpers.getLastAccessPage(this, book.id);
      return utils.getBookLink(book, lastPageAccessed ? lastPageAccessed : null);
    },
    goToStore: function() {
      return storeHelpers.goToStore(this);
    },
    needPurchase: function(book) {
      // Get permission for push notifcations when the user interacts with the library
      var t = this;
      Notification.requestPermission(function(status) {
        utils.log(t, 'Notification permission status:', status);
      });
      if (book.requirePurchase) {
        this.requirePurchase = true;
      }
    },
    showUnreadResources: function (book) {
      this.$router.push('/book/' + book.id + '/resources')
    },
    checkbookExpired: function(book) {
      if (book && book.licenceExpiryDateTime && moment().unix() > book.licenceExpiryDateTime) {
        // bookExpired: function(handle, bookId, expiryDate, deletedDate)
        analytics.bookExpired(this, book.id, book.licenceExpiryDateTime, moment().unix());
        return false;
      }
      return true;
    }
  }
}

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.unread {
  position: absolute;
  top: 45px;
  right: 5px;
  color: $lightest-font-color;
  padding: 5px 5px 24px 5px;
  height: 25px;
  font-size: 10pt;
  min-width: 24px;
  text-align: center; 
}

.unread:hover {
  background: $dark-font-color;
}

.unread-grid-view {
  width: 13px !important;
  height: 13px !important;
  border-radius: 50%;
  background: $primary-color;
  bottom: 10px;
  right: 10px;
  color: $lightest-font-color;
  padding: 0 5px 10px 5px;
  position: absolute;
  -webkit-box-shadow: 0px 0px 3px 0px rgba(255,255,255,1);
  -moz-box-shadow: 0px 0px 3px 0px rgba(255,255,255,1);
  box-shadow: 0px 0px 3px 0px rgba(255,255,255,1);
}

.details-wrapper {
  display: table;
  .tr {
    display: table-row;
    .info-title {
      display: table-cell;
      // border: 1px solid black;
      text-align: right;
      font-weight: bold;
      white-space: nowrap;
    }
    .info-value {
      display: table-cell;
      padding: 5px;
      // border: 1px solid black;
    }
  }
}
</style>